import { FlexContainer, FlexItem } from '~/components/Grid'
import { trackEvent } from '~/utils/tracking'
import { useLoaderData, useSearchParams } from '@remix-run/react'
import CIOPaginate from '~/components/CIOPaginate'
import { CategoryArticlePageData } from '~/routes/career-advice.$slug'

export type BlogPaginateProps = {
  total: number
  perPage: number
}

export const BlogPaginate = ({ total, perPage }: BlogPaginateProps) => {
  const [searchParams] = useSearchParams()
  const { currentCategory } = useLoaderData() as Pick<CategoryArticlePageData, 'currentCategory'>
  if (total <= perPage) return null
  const currentPage = searchParams.get('page') || '1'

  return (
    <div className="max-xl:rounded-b-[32px] rounded-b-[40px] max-xl:-mt-8 pt-5 max-md:pb-5 max-xl:pt-9 z-1 relative bg-white -mt-10">
      <FlexContainer justify="end">
        <FlexItem
          className="max-xl:max-w-[1000px] max-md:px-4 max-xl:px-8 max-xl:py-0 max-xl:my-0 max-xl:mx-auto"
          desktop={10}
          laptop={12}
        >
          <CIOPaginate
            itemsTotal={total}
            itemsPerPage={perPage}
            onPaginate={(pageNo) => {
              trackEvent('click_page_selector', {
                current_page: currentPage,
                new_page: pageNo,
                category: currentCategory?.fields?.name || '',
              })
            }}
          />
        </FlexItem>
      </FlexContainer>
    </div>
  )
}
